// @flow
import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';

type Action = {
  message: Node,
  onClick: Function,
};

export type NotificationProps = {
  message: Node,
  title: ?Node,
  icon: ?Node,
  onClose: Function,
  actions: Action[],
};
const NotificationRender = (props: NotificationProps) => {
  const { message, title, icon, actions, ...rest } = props;
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={3000}
      message={message}
      title={title}
      icon={icon}
      action={[
        actions,
        <Button key="buttonClose" onClick={() => props.onClose()} size="small">
          Close
        </Button>,
      ]}
      {...rest}
    />
  );
};

export default NotificationRender;



// WEBPACK FOOTER //
// /opt/build/repo/src/packages/notifications/components/NotificationRender.js